import './App.css';
import NavBar from './Components/NavBar';
import Search from './Components/Search';
import Hero from './Components/Hero';
import Programs from './Components/Programs';
import Reasons from './Components/Reasons';
import Plans from './Components/Plans';
import Monials from './Components/Monials';
import Join from './Components/Join';
import Footer from './Components/Footer';
function App() {
  return (
    <>
   
    <Hero/>
    <Programs/>
    <Reasons/>
    <div style={{height:"70px",backgroundColor:"var(--darkGrey)"}}>

    </div>
    <Plans/>
    <Monials/>
    <Join/>
    <Footer/>
    </>
  );
}

export default App;
